import { render, staticRenderFns } from "./product-auction.vue?vue&type=template&id=73e9193c&scoped=true&"
import script from "./product-auction.vue?vue&type=script&lang=js&"
export * from "./product-auction.vue?vue&type=script&lang=js&"
import style0 from "./product-auction.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./product-auction.vue?vue&type=style&index=1&id=73e9193c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e9193c",
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fquake%2Fworkspace%2Fauction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Fproducts%2Fproduct-auction.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports